import { atom } from "recoil";

export const weekTotalState = atom({
  key: "weekTotalState",
  default: 0,
});
